import {BehaviorSubject} from 'rxjs';

/**
 * The same as BehaviorSubject, but do not notify about not changed values.
 */
export class BehaviorSubjectSkipSame<T> extends BehaviorSubject<T> {

    public override next(value: T): void {
        if (value !== this.value) {
            super.next(value);
        }
    }

}
